export interface Lesson {
    className: string;
    lesson: string;
    date: string;
    link?: string;
    teacher?: string;
}

export const lessons: Array<Lesson> = [
    {
        "className": "Elders Quorum",
        "date": "2/28/2021",
        "lesson": "This Week's lesson",
        "teacher": "Matt Thompson",
        "link": "https://justserve.org",
    },
    {
        "className": "Elders Quorum",
        "date": "3/14/2021",
        "lesson": "Elder Dieter F. Uchtdorf - God Will Do Something Unimaginable",
        "teacher": "Matt Thompson",
        "link": "https://www.churchofjesuschrist.org/study/general-conference/2020/10/28uchtdorf?lang=eng",
    },
    {
        "className": "Elders Quorum",
        "date": "3/28/2021",
        "lesson": "Elder Jeffrey R. Holland - Waiting on the Lord",
        "teacher": "Ambrose Aukusitino",
        "link": "https://www.churchofjesuschrist.org/study/general-conference/2020/10/57holland?lang=eng",
    },
    {
        "className": "Elders Quorum",
        "date": "4/11/2021",
        "lesson": "Elder Carlos A. Godoy - I Believe in Angels",
        "teacher": "Matt Thompson",
        "link": "https://www.churchofjesuschrist.org/study/general-conference/2020/10/44godoy?lang=eng",
    },
    {
        "className": "Elders Quorum",
        "date": "4/25/2021",
        "lesson": "Elder Ronald A. Rasband - Recommended to the Lord",
        "teacher": "Harry Brock",
        "link": "https://www.churchofjesuschrist.org/study/general-conference/2020/10/16rasband?lang=eng",
    },
]